import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer-platform/page.tsx");
